<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M6.5,29.2a.8.8,0,0,1-.4-.11.78.78,0,0,1-.37-.48L.79,10.19a.79.79,0,0,1,.56-1l24-6.44a.79.79,0,0,1,1,.56l4.94,18.42a.79.79,0,0,1-.56,1l-24,6.44Zm-4-18.66L7.06,27.43l22.48-6L25,4.52Z"
        style="opacity:0.5" />
    <path
        d="M24.39,7.66A1.5,1.5,0,0,0,22.58,6.6l-17,4.54a1.5,1.5,0,0,0-1,1.81c.72,2.72,2.27,8.66,3,11.34a1.48,1.48,0,0,0,1.81,1.06l17-4.54a1.47,1.47,0,0,0,1-1.81Z"
    />
    <circle cx="1.52" cy="9.97" r="1.52" />
    <circle cx="6.46" cy="28.39" r="1.52" />
    <circle cx="30.48" cy="21.96" r="1.52" />
    <circle cx="25.53" cy="3.53" r="1.52" />
</svg>